import {madnes_show_money, madnes_stop_coin} from "../framework/src/engine/madnes/madnes_anims";
import {bet, madnes_money_to_coin} from "../framework/src/engine/madnes/madnes";
import {madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {
	madnes_get_scale_x,
	madnes_get_scale_y,
	madnes_get_visible,
	madnes_set_alpha,
	madnes_set_texture,
	madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {mega_win, picture_convert, super_win} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_add_to_render, madnes_alpha_to, madnes_rem_from_render} from "../framework/src/engine/madnes/madnes_render";
import {set_bigwin_type} from "./j81_reels";
import {madnes_audio_loop, madnes_audio_play, madnes_audio_stop} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";

var money_add_big_win_anim_step = 0;
export function set_money_add_big_win_anim_step(val) {
	money_add_big_win_anim_step = val;
}

var money_add_big_win_add_to_render;
var money_add_big_win_callback = function() {};
export function set_money_add_big_win_callback(func) {
	money_add_big_win_callback = func;
}

export function money_add_big_win_anim(max, from_freespin)
{
	switch(money_add_big_win_anim_step)
	{
		case 0:

			//setTimeout(function() {
				madnes_audio_play("YOU_WON");
			//}, 160);

			set_bigwin_type("bigwin");
			show_bigwin_table();


			money_add_big_win_anim_step = 1;
			money_add_big_win_anim(max, from_freespin);
			break;
		case 1:
			money_add_big_win_add_pos = 0;
			money_add_big_win_add_max = max;
			money_add_big_win_add_step = -1;

			money_add_big_win_add_to_render = money_add_big_win_add.bind(this, from_freespin);
			madnes_add_to_render(money_add_big_win_add_to_render);
			break;
		case 2:


			money_add_big_win_anim_step = 3;

			hide_bigwin_table();

			money_add_big_win_anim(max, from_freespin);

			break;
		case 3:

			money_add_big_win_anim_step = 0;

			money_add_big_win_callback();

			break;
	}
}

var money_add_big_win_add_pos = 0;
var money_add_big_win_add_max = 0;
var money_add_big_win_add_step = -1;
function money_add_big_win_add(from_freespin)
{
	/*var add = Math.floor(( (bet * big_win) / 100 ) * (Math.random() * 4));

	if(win_type == "FS_WIN_2")
	{
		add = Math.floor(( (bet * mega_win) / 100 ) * (Math.random() * 4));
	}
	if(win_type == "FS_WIN_3")
	{
		add = Math.floor(( win / 180 ) * (Math.random() * 4));
	}*/

	var tmp_add = Math.round( money_add_big_win_add_max * ( Math.random() / 100 ) );
	if(tmp_add < 1)
	{
		tmp_add = 1;
	}
	money_add_big_win_add_pos = money_add_big_win_add_pos * 1 + tmp_add;

	if(money_add_big_win_add_step == -1) {
		madnes_audio_loop('remittance_A');
		money_add_big_win_add_step = 0;
	}

	if(money_add_big_win_add_step == 0 && money_add_big_win_add_pos > bet * mega_win && !from_freespin)
	{
		//money_add_big_win_add_pos = madnes_get_money_bet(bet) * mega_win;
		money_add_big_win_add_step = 1;

		set_bigwin_type('megawin');
	}
	else if(money_add_big_win_add_step == 1 && money_add_big_win_add_pos > bet * super_win)
	{
		//money_add_big_win_add_pos = madnes_get_money_bet(bet) * super_win;
		money_add_big_win_add_step = 2;

		set_bigwin_type('supermegawin');

	}

	if(money_add_big_win_add_pos > money_add_big_win_add_max)
	{
		madnes_audio_stop('remittance_A');
		madnes_audio_play("remittance_B");

		money_add_big_win_add_pos = money_add_big_win_add_max;

		madnes_rem_from_render(money_add_big_win_add_to_render);
		money_add_big_win_anim_step = 2;

		if(money_add_big_win_add_max < 100) {
			setTimeout(function() {
				madnes_stop_coin();
			}, 2000);
			setTimeout(money_add_big_win_anim.bind(this, money_add_big_win_add_max, from_freespin), 3000);
		}
		else
		{
			madnes_stop_coin();
			setTimeout(money_add_big_win_anim.bind(this, money_add_big_win_add_max, from_freespin), 3000);
		}
	}

	windesk_setsum(money_add_big_win_add_pos);
}

var windesk_setsum_buffer = new Array();
function windesk_setsum(sum)
{
	madnes_set_text('bigwin_text', sum | 0);
}

var freespin_state = new Array();

/**
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @param {Function=} cb
 */
export function madnes_fade_out(name, duration, delay, cb)
{
	if(delay == 'undefined' || !delay) {
		delay = 0;
	}

	setTimeout(madnes_alpha_to.bind(this, name, 0, duration, cb), delay);
}

/**
 * @param {string} name
 * @param {number} duration
 * @param {number=} delay
 * @param {Function=} cb
 */
export function madnes_fade_in(name, duration, delay, cb)
{
	if(delay == 'undefined' || !delay) {
		delay = 0;
	}

	setTimeout(madnes_alpha_to.bind(this, name, 1, duration, cb), delay);
}

function madnes_anim_pulse(name, xScale, yScale, duration, delay, cb)
{

	var origScaleX = madnes_get_scale_x(name);
	var origScaleY = madnes_get_scale_y(name);

	setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration), delay);
	setTimeout(madnes_scale_to.bind(this, name, origScaleX, origScaleY, duration), duration + delay, cb);
}

function madnes_anim_scale(name, xScale, yScale, duration, delay, callback)
{
	setTimeout(madnes_scale_to.bind(this, name, xScale, yScale, duration, callback), delay);
}

function madnes_anim_blink(name, count, duration, callback)
{
	setTimeout(function() {

		madnes_set_visible(name, !madnes_get_visible(name));

		if(count >= 0) {
			madnes_anim_blink(name, --count, duration, callback);
		} else {
			if(typeof callback == 'function') {
				callback();
			}
		}
	}, duration);
}

/** @param {Function=} callback  */
function show_bigwin_table(callback)
{
	madnes_set_alpha("bigwin_group", 0);
	madnes_set_visible("bigwin_group", true);
	madnes_alpha_to("bigwin_group", 1, 500, callback);
}

/** @param {Function=} callback */
function hide_bigwin_table(callback)
{
	madnes_set_alpha("bigwin_group", 1);
	madnes_alpha_to("bigwin_group", 0, 500, function() {

		madnes_set_visible("bigwin_group", false);

		if(typeof callback === 'function') {
			callback();
		}
	});
}

export function anims_scale_symbols(symbols) {

	return new Promise(function(res) {

		setTimeout(function() {

			for(var i in symbols) {

				var symbol = symbols[i];

				var tmpSpriteName = symbol['tmpSpriteName'];

				(function(tmpSpriteName) {

					madnes_tween_to(tmpSpriteName, { 'x': 1.1, 'y': 1.1 }, {
						'scale': true,
						'duration': 300,
						'yoyo': true,
						'callback': res
					});

				} (tmpSpriteName));
			}
		}, 200);
	});
}

function anims_fade_jokers(symbols, win_set) {

	return new Promise(function(res) {

		for(var i in symbols) {

			(function(symbol) {

				if(symbol['isJoker']) {

					madnes_tween_to(symbol['tmpSpriteName'], { 'alpha': 0 }, {
						'duration': 200,
						'callback': function() {

							madnes_set_texture(symbol['tmpSpriteName'], picture_convert[win_set['symbol']]);

							madnes_tween_to(symbol['tmpSpriteName'], { 'alpha': 1 }, {
								'duration': 200,
								'callback': res
							});
						}
					});
				}

			} (symbols[i]));
		}

	});
}

export function anims_money_add_win_anim(won)
{
	return new Promise(function (res) {

		madnes_show_money(madnes_money_to_coin(won), res);

	});
}